export const myreducer = (state,action) =>{
    if(action.type === 'ITEM_ADDED_H'){
        let itemadded = state.devices[0].map((item) =>{
            if(item.id === action.payload){
                return {
                    ...item,
                    inCart:true,
                    count: item.count+1,
                    total:item.total+item.price
                }
            }
            return item
        })
        let itemadded2 = state.devices[1].map((item) =>{
            if(item.id === action.payload){
                return {
                    ...item,
                    inCart:true,
                    count: item.count+1,
                    total:item.total+item.price
                }
            }
            return item
        })
        let itemadded3 = state.devices[2].map((item) =>{
            if(item.id === action.payload){
                return {
                    ...item,
                    inCart:true,
                    count: item.count+1,
                    total:item.total+item.price
                }
            }
            return item
        })


        state.devices[0] = itemadded
        state.devices[1] = itemadded2
        state.devices[2] = itemadded3
        let filteradded = itemadded.filter((item)=> item.inCart === true)
        let filteradded2 = itemadded2.filter((item)=> item.inCart === true)
        let filteradded3 = itemadded3.filter((item)=> item.inCart === true)
        // console.log(...filteradded);
        // let allfilterdata = {filteradded,filteradded2,filteradded3}
        return {
            ...state,
            devices:state.devices,
            cart:[...filteradded,...filteradded2,...filteradded3]
        }
    }
    if(action.type === "CLEAR_CART"){
        let clearItem = state.devices[0].map((item)=>{
            return {
                ...item,
                inCart:false,
                count:0,
                total:0
            }
        })
        let clearItem2 = state.devices[1].map((item)=>{
            return {
                ...item,
                inCart:false,
                count:0,
                total:0
            }
        })
        let clearItem3 = state.devices[2].map((item)=>{
            return {
                ...item,
                inCart:false,
                count:0,
                total:0
            }
        })
        state.devices[0] = clearItem
        state.devices[1] = clearItem2
        state.devices[2] = clearItem3
        return {
            ...state,
            devices:state.devices,
            cart:[]
        }
    }
    if(action.type === '++_COUNT'){
        let getCount = state.cart.map((item)=>{
            if(item.id === action.payload){
                return {
                    ...item,
                    count:item.count+1,
                    total: item.total+item.price
                }
            }
            return item
        })
        
        let itemadded = state.devices[0].map((item) =>{
            if(item.id === action.payload){
                return {
                    ...item,
                    inCart:true,
                    count: item.count+1,
                    total:item.total+item.price
                }
            }
            return item
        })
        let itemadded2 = state.devices[1].map((item) =>{
            if(item.id === action.payload){
                return {
                    ...item,
                    inCart:true,
                    count: item.count+1,
                    total:item.total+item.price
                }
            }
            return item
        })
        let itemadded3 = state.devices[2].map((item) =>{
            if(item.id === action.payload){
                return {
                    ...item,
                    inCart:true,
                    count: item.count+1,
                    total:item.total+item.price
                }
            }
            return item
        })
        state.devices[0] = itemadded
        state.devices[1] = itemadded2
        state.devices[2] = itemadded3


        return {
            ...state,
            devices:state.devices,
            cart:getCount
        }
    }
    if(action.type === "--_COUNT"){
        let getCount = state.cart.map((item)=>{
            if(item.id === action.payload){
                return {
                    ...item,
                    count:item.count-1,
                    total: item.total-item.price
                }
            }
            return item
        })

        let giveFalse = getCount.map((item)=>{
            if(item.count === 0){
                return {
                    ...item,
                    inCart:false,
                    count:0
                }
            }
            return item
        })
        // console.log(giveFalse[0].inCart);

        let givedevicesfalse = state.devices[0].map((item)=> {
            if(item.id === action.payload && giveFalse[0].count === 0 ){
                return {
                    ...item,
                    inCart:false,
                    count: 0,
                    total:0
                }
            }
            return item
        })
        let givedevicesfalse2 = state.devices[1].map((item)=> {
            if(item.id === action.payload && giveFalse[0].count === 0 ){
                return {
                    ...item,
                    inCart:false,
                    count: 0,
                    total:0
                }
            }
            return item
        })
        let givedevicesfalse3 = state.devices[2].map((item)=> {
            if(item.id === action.payload && giveFalse[0].count === 0 ){
                return {
                    ...item,
                    inCart:false,
                    count: 0,
                    total:0
                }
            }
            return item
        })
        state.devices[0]=givedevicesfalse
        state.devices[1]=givedevicesfalse2
        state.devices[2]=givedevicesfalse3

        let givezero = getCount.filter((item)=> item.count !== 0)
        // console.log(givezero);
        return {
            ...state,
            devices:state.devices,
            cart:givezero
        }
    }
    if(action.type === "GET_TOTALS"){
        let {total} = state.cart.reduce((cartTotals,cartItem)=>{
            const {count,total} = cartItem
            // const itemTotal = count*total
            cartTotals.total += total
            cartTotals.count += count;
            return cartTotals
        },{
            total:0
        })
        total = parseFloat(total.toFixed(2))
        return {...state,amount:total}
    }
}